<div style="border-radius: 12px;"
     class="flex flex-column height-100 b-a b-col-5 overflow-hidden">

    <a [routerLink]="model?.data?.url || ''">
        <!-- image -->
        <df-image-wrapper>
            <img [ratio]="'3/2'"
                 [dfImage]="model?.data?.image || ''"
                 [alt]="model?.data?.name || ''">
        </df-image-wrapper>
    </a>

    <div class="center bg-col-52 p-l-5 p-r-5 p-b-3 p-l-4-s p-l-4-m p-r-4-s p-r-4-m flex-grow flex flex-column">
        <!-- tags -->
        @if (tagCategories?.length) {
        <ul class="m-t">
            @for (tag of tagCategories; track tag) {
            <li [class.m-l-1]="!$first"
                style="border-radius: 12px;"
                class="c1 col-1 bg-col-62 p-r-2 p-l-2 p-a-1 m-b-1 _tag inline-block">
                <a [routerLink]="tag.data?.url || ''">
                    {{tag.name}}
                </a>
            </li>
            }
        </ul>
        }

        <!-- inner part -->
        <a [routerLink]="model?.data?.url || ''"
           class="flex-grow">
            <!-- title -->
            <p class="h4 m-t-4">
                {{model?.name}}
            </p>
        </a>
        <!-- Read more -->
        <a [routerLink]="model?.data?.url || ''">
            <span class="m-t s1 b-b b-col-1 inline-block">
                {{'Read article' | translate}}
            </span>
        </a>
    </div>
</div>